import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import asyncRefresh from './store/thunks/auth/asyncRefresh';

import Authorization from './Pages/Authorization/Authorization';
import Employees from './Pages/Employees/Employees';
import Accounting from './Pages/Accounting/Accounting';

import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';

import './App.scss';
import { setIsAuth } from './store/slices/authSlice';
import useTitle from './hooks/useTitle';

function App() {
  useTitle("Личный кабинет");

  const isAuth = useSelector(state => state.auth.isAuth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const accessToken = sessionStorage.access;
    if (!accessToken) {
      dispatch(asyncRefresh());
    } else {
      dispatch(setIsAuth(true));
    }
  }, [])

  useEffect(() => {
    const {pathname} = location;
    if (!pathname.includes("/view")) {
      !isAuth && navigate('/auth');
    }
  }, [isAuth]);

  return (
    <>
      <Header isAuth={isAuth}/>
      <Routes>
        <Route path="/view/:uuid" element={<Accounting />}/>
        <Route path="/employees" element={<Employees />} />
        <Route path="/auth">
          <Route path="" element={<Authorization />} />
        </Route>
      </Routes>
      <Footer />
    </>
  );
}

export default App;
